<template>
  <div class="header-wrap">
    <div class="form-wrap">
      <el-form :model="this" :rules="rules" ref="headerTplRef">
        <div class="form-item">
          <span class="item-label">选择模板：</span>
          <div class="item-value">
            <el-button
              class="add-tpl"
              icon="el-icon-plus"
              type="text"
              @click="selectTpl"
              >选择模板</el-button
            >
            <span v-show="tplMsg.tplName" class="tpl-label"
              >模板名称：{{ tplMsg.tplName }}</span
            >
          </div>
        </div>
        <div class="form-item">
          <span class="item-label" style="padding-top: 6px">广告账户：</span>
          <div class="item-value">
            <el-form-item
              prop="adCount"
              style="margin-bottom: 0px"
              class="select-count-formItem"
            >
              <span class="select-tip">请选择</span>
              <el-select
                v-model="adCount"
                multiple
                :multiple-limit="1"
                placeholder=""
                class="count-select-wrap"
                popper-class="count-select"
                value-key="advertiserId"
                @change="searchProList()"
              >
                <el-option
                  v-for="item of countList"
                  :key="item.advertiserId"
                  :label="item.advertiserId"
                  :value="item"
                >
                  <div class="count-option">
                    <span class="count-item">{{ item.company }}</span>
                    <span class="count-item">ID：{{ item.advertiserId }}</span>
                  </div>
                </el-option>
              </el-select>
              <ul class="select-list" v-show="adCount.length > 0">
                <li
                  class="select-item"
                  v-for="item of adCount"
                  :key="item.advertiserId"
                >
                  {{ item.company }}-{{ item.advertiserId
                  }}<span
                    class="close-btn"
                    @click="deleteItem(item.advertiserId)"
                    >×</span
                  >
                </li>
              </ul>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>

    <!-- 模板选择弹框 -->
    <el-dialog title="选择模板" :visible.sync="dialogVisible" width="1014px">
      <div class="modal-body">
        <div class="select-filter">
          <el-select
            style="width: 224px"
            v-model="modalData.adCount"
            placeholder="请选择"
            @change="getTemplateList"
          >
            <el-option label="全部广告账号" :value="-1"> </el-option>
            <el-option
              :label="item.company + '(' + item.advertiserId + ')'"
              :value="item.advertiserId"
              v-for="item of countList"
              :key="item.advertiserId"
            >
            </el-option>
          </el-select>
          <el-input
            style="width: 224px"
            placeholder="请搜索模板名称"
            suffix-icon="el-icon-search"
            @change="getTemplateList"
            clearable
            v-model.trim="modalData.templateName"
          >
          </el-input>
        </div>
        <div class="table-wrap">
          <el-table
            :data="tplTableList"
            style="width: 100%"
            @select="selectRow"
            ref="tplTableRef"
            max-height="500px"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="id" label="序号"> </el-table-column>
            <el-table-column prop="templateName" label="名称">
            </el-table-column>
            <el-table-column prop="templateDesc" label="描述">
            </el-table-column>
            <el-table-column prop="advertiserIds" label="关联账号">
              <template slot-scope="scope">
                <div
                  v-for="item in scope.row.advertiserIds.split(',')"
                  :key="item"
                >
                  {{ item }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" width="170" label="创建时间">
            </el-table-column>
            <el-table-column prop="creator" label="创建人"> </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="footer-wrap">
          <self-pagination
            :total="modalData.pageData.total"
            :pageSize="modalData.pageData.size"
            :currentPage="modalData.pageData.page"
            ref="tabelPagination"
            @getCurrentPage="changePage"
            @handleSizeChange="changePageSize"
          ></self-pagination>
          <div></div>
          <div class="bottom-wrap">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirmSelect">确 定</el-button>
          </div>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAdCountList,
  queryTemplate,
  getAdTemplateDatail,
} from "@/api/promotion-gdt.js";
export default {
  data() {
    return {
      adCount: [],
      countList: [],
      dialogVisible: false,

      modalData: {
        adCount: -1,
        templateName: "",
        pageData: {
          total: 15,
          page: 1,
          size: 10,
        },
      },
      tplTableList: [],
      tplMsg: {
        tplId: "", //保存的时候需要
        tplDes: "",
        tplName: "",
      },
      selectData: null, //勾选的模板数据
      rules: {
        adCount: [
          {
            required: true,
            type: "array",
            message: "请选择一个账户",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {
    this.initSelect();
  },
  methods: {
    initSelect() {
      getAdCountList({ platType: 2 }).then((res) => {
        if (res.code === "0000") {
          this.countList = res.advertiseInfos;
        }
      });
    },
    searchProList() {
      this.$store.commit("setadCount_gdt", this.adCount);
      this.$store.commit("set_basic_draft_adset_promotedId_gdt", {
        promotedObjectId: "",
        promotedObjectName: "",
        channelPackageItems: [],
      });
    },
    getTemplateList() {
      queryTemplate({
        pageNum: this.modalData.pageData.page,
        pageSize: this.modalData.pageData.size,
        platform: 2,
        advertiserIds:
          this.modalData.adCount === -1 ? null : this.modalData.adCount,
        templateName: this.modalData.templateName,
      }).then((res) => {
        if (res.code === "0000") {
          this.tplTableList = res.data.list;
          this.modalData.pageData.total = res.data.total;
        }
      });
    },
    changePage(page) {
      this.modalData.pageData.page = page;
      this.getTemplateList();
    },
    changePageSize(size) {
      this.modalData.pageData.page = 1;
      this.modalData.pageData.size = size;
      this.getTemplateList();
    },
    selectTpl() {
      this.dialogVisible = true;
      this.getTemplateList();
    },
    selectRow(selection, row) {
      this.selectData = row;
      this.$refs.tplTableRef.clearSelection();
      this.$refs.tplTableRef.toggleRowSelection(row, true);
    },
    confirmSelect() {
      if (this.selectData) {
        this.dialogVisible = false;
        this.renderData();
      } else {
        this.$message({
          message: "请选择一条模板数据",
          type: "warning",
        });
      }
    },
    deleteItem(advertiserId) {
      let index = this.adCount.findIndex(
        (item) => item.advertiserId === advertiserId
      );
      if (index !== -1) {
        this.adCount.splice(index, 1);
        this.searchProList();
      }
    },
    //数据回显
    async renderData() {
      const { id, templateName, templateDesc, advertiserIds } = this.selectData;
      this.tplMsg.tplId = id;
      this.tplMsg.tplName = templateName;
      this.tplMsg.tplDes = templateDesc;
      //赋值广告账号
      if (advertiserIds) {
        let ids = advertiserIds
          .split(",")
          .map((item) => item.replace(/^\s+|\s+$/g, ""));
        let checkedData = [];
        this.countList.forEach((item) => {
          if (ids.includes(item.advertiserId)) {
            checkedData.push(item);
          }
        });
        this.adCount = checkedData;
        this.$store.commit("setadCount_gdt", this.adCount);
      }
      const res = await getAdTemplateDatail({ id });
      //表单赋值
      const data = JSON.parse(res.data.templateData);
      this.searchProList(); //带赋值的查询
      // 基础设置
      this.$store.commit("set_basic_draft_adset_gdt", data.draftAdSet);
      // 推广计划
      this.$store.commit("set_draft_campaign_gdt", data.draftCampaign);
      // 定向包
      this.$store.commit("set_draft_targeting_gdt", data.draftTargetings);
      // 创意组
      this.$store.commit(
        "set_draft_creative_gdt",
        data.draftCreative.creativeGroups
      );
      // 创意标题
      this.$store.commit(
        "set_draft_creative_title_gdt",
        data.draftCreative.textGroups
      );
      // 创意组和创意标题原始数据用于回显
      this.$store.commit("set_origin_draft_creative_gtd", data.draftCreative);
      // 预算和出价原始数据
      this.$store.commit("set_origin_draft_budgets_gdt", data.draftBudgets);
      // 其他配置
      this.$store.commit("set_draft_extra_config_gdt", data.draftExtraConfig);
      // 分配规则
      this.$store.commit("set_split_rule_gdt", data.splitRule);
      // 推广目标类型
      this.$store.commit(
        "set_spread_target_gdt",
        data.draftCampaign.promotedObjectType
      );
    },
    checkData() {
      return new Promise((resolve, reject) => {
        this.$refs.headerTplRef.validate((valid) => {
          if (valid) {
            resolve();
          } else {
            reject();
          }
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.header-wrap {
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .form-wrap {
    padding: 18px 24px 24px 24px;
    .form-item {
      display: flex;
      margin-bottom: 12px;
      .item-label {
        flex-shrink: 0;
        display: inline-block;
        width: 70px;
        text-align: right;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
      }
      .item-value {
        position: relative;
        width: 100%;
        padding-top: 2px;
        /deep/ .el-radio__input.is-checked .el-radio__inner {
          color: rgba(24, 144, 255, 1);
          border-color: rgba(24, 144, 255, 1);
          background: rgba(24, 144, 255, 1);
        }
        /deep/ .el-radio__input.is-checked + .el-radio__label {
          color: rgba(24, 144, 255, 1);
        }
        /deep/ .el-form-item__content {
          line-height: 20px;
        }
        /deep/ .select-count-formItem {
          .el-form-item__error {
            left: 75px;
            top: 7px;
          }
        }
        .add-tpl {
          padding: 0px;
        }
        .tpl-label {
          font-size: 12px;
          margin-left: 10px;
        }
        .select-tip {
          color: rgba(0, 0, 0, 0.85);
          font-size: 14px;
          position: absolute;
          top: 4px;
          left: 0px;
          z-index: 100;
          pointer-events: none;
        }
        .count-select-wrap {
          width: 75px;
          /deep/ .el-select__tags {
            display: none;
          }
          /deep/ .el-input__inner {
            border: none;
          }
          /deep/.el-select .el-input .el-select__caret {
            color: red;
          }
        }
        .select-list {
          margin: 0px;
          padding: 12px 12px 0px 12px;
          box-sizing: border-box;
          list-style: none;
          border-radius: 4px;
          border: 1px solid rgba(239, 239, 239, 1);
          background: rgba(252, 252, 252, 1);
          display: flex;
          flex-wrap: wrap;
          max-height: 125px;
          overflow: auto;
          .select-item {
            color: rgba(0, 0, 0, 0.65);
            font-size: 14px;
            border-radius: 2px;
            background: rgba(233, 233, 233, 0.6);
            padding: 2px 5px;
            margin: 0 12px 12px 0;
            white-space: nowrap;
            .close-btn {
              display: inline-block;
              margin-left: 6px;
              font-size: 18px;
              cursor: pointer;
              position: relative;
              top: 1px;
            }
          }
        }
      }
    }
  }
  .modal-body {
    .select-filter {
      display: flex;
      justify-content: space-between;
      margin-bottom: 14px;
    }
    .table-wrap {
      min-height: 400px;
    }
    .footer-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .bottom-wrap {
        display: flex;
        padding: 16px;
      }
      /deep/ .pagination-wrap {
        text-align: left;
      }
    }
  }
}
</style>
<style lang="less">
.pro-select {
  .el-select-dropdown__item {
    height: 45px;
    line-height: 45px;
  }
  .seitem-wrap {
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0px;
    box-sizing: border-box;
    .img-wrap {
      width: 30px;
      height: 30px;
      margin-right: 10px;
      .app-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .seitem-content {
      font-size: 12px;
      .app-detail {
        display: block;
        line-height: 16px;
      }
    }
    .os-icon {
      margin: 0 0px 0 auto;
      font-size: 18px;
    }
  }
}
.count-select {
  .el-select-dropdown__item {
    height: 45px;
    line-height: 45px;
  }
  .count-option {
    font-size: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    .count-item {
      display: block;
      line-height: 20px;
    }
  }
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  background-color: rgba(24, 144, 255, 0.1);
  color: rgba(24, 144, 255, 1);
}
</style>
